import { Component, ViewChild } from '@angular/core';
import { MatSort, Sort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { LocalService } from '../../../services/shared/local.service';
import { BCMCLPUser, TeamCodes } from '../../../models/clpuser.model';
import { HttpErrorResponse } from '@angular/common/http';
import { MembershipService } from '../../../services/membership.service';
import { GlobalService } from '../../../services/shared/global.service';
import { UtilityService } from '../../../services/shared/utility.service';
import { TeamOfficeService } from '../../../services/team-office.service';
import { UserService } from '../../../services/user.service';
import { CMClubService } from '../../../services/cm-club.service';
import { CMClub, CMClubResponse, CMSite, CMSiteListResponse } from '../../../models/cm-club-service.model';
import { Subject, Subscription, takeUntil } from 'rxjs';
import { Router } from '@angular/router';
import { MemSubscription, MemSubscriptionListRequest, MemSubscriptionResponse, REF_SubscriptionStatus } from '../../../models/membership.model';
import { UserDD } from '../../../models/generic-response.model';
import { FormControl, FormGroup } from '@angular/forms';
import { DatePipe } from '@angular/common';

@Component({
    selector: 'app-mem-subscription-list',
    templateUrl: './mem-subscription-list.component.html',
    styleUrls: ['./mem-subscription-list.component.css']
})

/** mem-subscription-list component*/
export class MemSubscriptionListComponent {
    @ViewChild(MatSort) sort: MatSort;
    @ViewChild(MatPaginator) paginator: MatPaginator;
    memSubscriptionListSource: MatTableDataSource<any>;
    memSubscriptionListDisplayColumns: string[] = [];
    columns = [{ field: 'contactName', title: 'Name', width: '20' },
    { field: 'subscriptionName', title: 'Subscription', width: '20' },
    { field: 'paymentType', title: 'Payment Type', width: '80' },
    { field: 'baseAmount', title: 'Base Amount', width: '150' },
    { field: 'paused', title: 'Paused', width: '40' },
    { field: 'subscriptionStatus', title: 'Status', width: '40' },
    { field: 'coupon', title: 'Coupon', width: '40' },
    { field: 'billingDay', title: 'Billing Day', width: '40' },
    { field: 'dtNextBill', title: 'Next Bill Date', width: '40' }]


    encryptedUser: string;
    user: BCMCLPUser;
    teamSub: Subscription;
    curTeam: TeamCodes = <TeamCodes>{};
    showSpinner: boolean;
    clubConfig: CMClub;
    cmSites: CMSite[];
    memSubscriptions: MemSubscription[];

    selectedCMSiteID: number = 0;
    clpUsersDD: UserDD[];
    selectedUserID: number = 0;
    subscriptionStatusID: number = 0;
    createDateFilters = [
        {
            "value": 1,
            "name": "This Month"
        },
        {
            "value": 2,
            "name": "Last Month"
        },
        {
            "value": 3,
            "name": "Custom"
        }
    ]
    customFilter: boolean = false;
    customDateStr: string = '';
    selectedCtDtFilterName: string;
    selectedCtDtFilter: number = 1;
    currentRange = new FormGroup({
        start: new FormControl<Date | null>(null),
        end: new FormControl<Date | null>(null),
    });
    selectedCustomdtStart: string;
    selectedCustomdtEnd: string;
    sites: number[];
    users: any[];
    ref_SubscriptionStatus_List: REF_SubscriptionStatus[];
    private destroy$ = new Subject<void>();

    constructor(private localService: LocalService,
        private membershipService: MembershipService,
        public _localService: LocalService,
        private _globalService: GlobalService,
        private _utilityService: UtilityService,
        private _teamOfficeService: TeamOfficeService,
        private userService: UserService,
        private _router: Router,
        private datePipe: DatePipe,
        private clubService: CMClubService
    ) {
        this.localService.setShowMenu(true);
        this.localService.setIsContract(false);
        this.localService.setIsMembership(true);
        this.localService.updateTeamDD(true);
        this.localService.setRouteName("mem-subscription-list");
    }

    ngOnInit() {
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
        this.timeouts.forEach(id => clearTimeout(id));
        this.timeouts.clear();
    }

    ngAfterViewInit() {
        this.encryptedUser = localStorage.getItem("token");
        if (this.encryptedUser) {
            this.authenticateR().then(() => {
                if (this.user) {
                    this.loadData()
                }
                else {
                    this._router.navigate(['/unauthorized']);
                }
            });
        }
        else {
            this._router.navigate(['/unauthorized']);
        }
    }

    async loadData() {
        this.teamSub = this._teamOfficeService.curTeam.pipe(takeUntil(this.destroy$)).subscribe(async (data: any) => {
            if (data != 0 && data != null) {
                this.curTeam = data
                if (this.curTeam?.teamCode > 0) {
                    await this.CMClub_Get();
                    await this.siteSearch();
                    this.memSubscription_GetList();
                    this.cLPUserGetListByTeamCode(this.user.cLPCompanyID, this.user?.cLPUserID);
                    this.ref_SubscriptionStatus_List = this._localService.refMem_GetAllResponse.ref_SubscriptionStatus_List;
                }
            }
            else {
                this.curTeam = JSON.parse(localStorage.getItem("curTeam") || "{}")
                if (this.curTeam?.teamCode > 0) {
                    await this.CMClub_Get();
                    await this.siteSearch();
                    this.memSubscription_GetList();
                    this.cLPUserGetListByTeamCode(this.user.cLPCompanyID, this.user?.cLPUserID);
                    this.ref_SubscriptionStatus_List = this._localService.refMem_GetAllResponse.ref_SubscriptionStatus_List;
                }
            }
        })
    }

    async CMClub_Get() {
        if (this.curTeam?.teamCode > 0) {
            this.showSpinner = true
            await this.clubService.CMClub_Get(this.encryptedUser, this.user?.cLPCompanyID, this.curTeam?.teamCode).
                then(async (result: CMClubResponse) => {
                    if (result) {
                        let response = UtilityService.clone(result);
                        this.clubConfig = response?.clubConfig
                    }
                    this.showSpinner = false
                })
                .catch((err: HttpErrorResponse) => {
                    this.showSpinner = false
                    this._globalService.error("site-fields.clubConfigGet", err.message, null,
                    );
                    this._utilityService.handleErrorResponse(err);
                });
        }
    }

    async siteSearch() {
        if (this.clubConfig?.clubId > 0) {
            await this.clubService.siteSearch(this.encryptedUser, 0, this.clubConfig?.clubId, 0, 0).
                then(async (result: CMSiteListResponse) => {
                    if (result) {
                        let response = UtilityService.clone(result);
                        this.cmSites = response?.sites;

                    }
                })
                .catch((err: HttpErrorResponse) => {
                    this._globalService.error("site-fields.clubConfigGet", err.message, null,
                    );
                    this._utilityService.handleErrorResponse(err);
                });
        }
    }

    private async authenticateR() {
        await this.localService.authenticateUser(this.encryptedUser)
            .then(async (result: BCMCLPUser) => {
                if (result) {
                    this.user = UtilityService.clone(result);
                    if (result?.strToken && result?.strToken != '') {
                        this.encryptedUser = result?.strToken;
                    }
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("navMenu.authenticateR", err.message, null);
                this._utilityService.handleErrorResponse(err);
            });
    }

    setGrid(list) {
        this.memSubscriptionListDisplayColumns = this.columns.map(c => c.field);
        this.memSubscriptionListSource = new MatTableDataSource(list);
        this.addTimeout(() => {
            this.memSubscriptionListSource.paginator = this.paginator;
            if (this.paginator) {
                this.paginator.pageSize = 50;
            }
            if (this.sort) {
                this.memSubscriptionListSource.sort = this.sort;
            }
        }, 500)

    }

    async memSubscription_GetList() {
        let request: MemSubscriptionListRequest = <MemSubscriptionListRequest>{};
        request.clubId = this.clubConfig?.clubId;
        request.dateType = 1;
        request.subscriptionStatus = this.subscriptionStatusID;
        request.sites = this.sites;
        request.strdtEnd = this.selectedCustomdtEnd;
        request.strdtStart = this.selectedCustomdtStart;
        request.timeFrame = this.selectedCtDtFilter;
        request.users = this.users;

        await this.membershipService.memSubscription_GetList(this.encryptedUser, request, this.user?.cLPUserID)
            .then(async (result: MemSubscriptionResponse) => {
                if (result) {
                    let response = UtilityService.clone(result);
                    this.memSubscriptions = response?.subscriptions;
                    this.setGrid(this.memSubscriptions);
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("contact-task.getLoadUsers", err.message, null,
                );
                this._utilityService.handleErrorResponse(err);
            });
    }

    async onChangeUserDD() {
        if (this.selectedUserID > 0) {
            this.users = [];
            this.users.push(this.selectedUserID);
            await this.memSubscription_GetList();
        } else {
            this.users = [];
            await this.memSubscription_GetList();
        }
    }

    async onChangeCMSite() {
        if (this.selectedCMSiteID > 0) {
            this.sites = [];
            this.sites.push(this.selectedCMSiteID);
            await this.memSubscription_GetList();
        } else {
            this.sites = [];
            await this.memSubscription_GetList();
        }
    }

    async onChangeStatus() {
        await this.memSubscription_GetList();
    }

    async createDtFilterChange() {
        let value = this.selectedCtDtFilter;

        if (value != 3) {
            this.selectedCtDtFilter = +value;
            await this.memSubscription_GetList();
        }
        else {
            this.customDateStr = ''
            this.customFilter = true;
        }
    }

    revertCustomFinalizeddtFilter() {
        this.customFilter = false;
        this.selectedCtDtFilter = 1;
        this.selectedCtDtFilterName = "This Month";
        this.currentRange = new FormGroup({
            start: new FormControl<Date | null>(null),
            end: new FormControl<Date | null>(null),
        });
        this.memSubscription_GetList();
    }


    dateRangeChange(dateRangeStart: HTMLInputElement, dateRangeEnd: HTMLInputElement) {
        var startDt = dateRangeStart.value;
        var endDt = dateRangeEnd.value;
        if (startDt) {
            let customdtStart = this.datePipe.transform(startDt, 'MMddyyyy');
            this.selectedCustomdtStart = customdtStart;

        }
        if (endDt) {
            let customdtEnd = this.datePipe.transform(endDt, 'MMddyyyy');
            this.selectedCustomdtEnd = customdtEnd;
            //this.selectedCtDtFilter = 3;
            this.selectedCtDtFilterName = "Custom"
            if (this.selectedCustomdtStart && this.selectedCustomdtEnd != null) {
                this.memSubscription_GetList();
            }
        }
    }

    applyFilter(filterValue: string) {
        filterValue = filterValue.trim().toLowerCase();
        if (this.memSubscriptionListSource) {
            this.memSubscriptionListSource.filter = filterValue;
        }
    }

    async cLPUserGetListByTeamCode(clpCompanyId, teamCode) {
        await this.userService.cLPUserGetListByTeamCode(this.encryptedUser, clpCompanyId, teamCode ? teamCode : this.user?.cLPUserID).
            then(async (result: UserDD[]) => {
                if (result) {
                    let response = UtilityService.clone(result);
                    this.clpUsersDD = response
                    this.clpUsersDD.unshift({
                        value: 0,
                        text: "--ALL--"
                    })
                }

            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("contact-task.getLoadUsers", err.message, null,
                );
                this._utilityService.handleErrorResponse(err);
            });
    }

    selectRow(row: any): void {
        if (!row?.subscriptionID) return;
        const url = `/mem-subscription?subscriptionID=${row.subscriptionID}`;
        window.open(url, '_blank');
    }
    navToMemContact(contactID) {
        let url = 'mem-contact/' + contactID;
        window.open(url, '_blank');
    }

    private timeouts = new Set<ReturnType<typeof setTimeout>>();
    addTimeout(callback, timeout) {
        const id = setTimeout(() => {
            if (callback) {
                callback();
            }
            this.timeouts.delete(id);
        }, timeout);
        this.timeouts.add(id);
    }

}
